import styled from 'styled-components';

const Wrapper = styled.div`
	position: relative;
	.img-container {
		width: 100%;
		height: 365px;
		background: #f6f6f6;
		position: relative;
		img {
			position: absolute;
			left: 30%;
			bottom: -83px;
			transform: translateX(-50%);
			width: 600px;
		}
		.setup-btn {
			position: absolute;
			right: 10%;
			top: 70px;
			width: 260px;
			text-align: center;
			.ant-btn {
				font-size: 28px;
				height: auto;
				margin-bottom: 8px;
			}
			.download {
				text-decoration: underline;
				color: #00f;
				cursor: pointer;
			}
		}
	}
	.info-container {
		padding-top: 100px;
		padding-left: 10%;
		text-align: left;
		h2 {
			font-size: 35px;
		}
		.ant-btn {
			margin-top: 22px;
			font-size: 48px;
			height: auto;
		}
		p {
			margin: 0;
			line-height: 1.6;
			color: #000;
			b {
				padding-right: 4px;
			}
		}
	}
	.activation-code {
		.hide {
			color: #000;
			background-color: #000;
		}
	}
	.logo-img {
		height: 35px;
		vertical-align: top;
	}
	&.isNew {
		.img-container {
			img {
				left: 50%;
			}
		}
		.info-container {
			width: 610px;
			margin: auto;
			padding-top: 100px;
			text-align: center;
			h2 {
				font-size: 28px;
			}
			.ant-btn {
				margin-top: 22px;
				font-size: 48px;
				height: auto;
			}
		}
	}
	.expired {
		color: #FF0000;
	}

	@media (max-width: 1600px) {
		.img-container {
			img {
				width: 50%;
				bottom: -60px;
			}
		}
	}
	@media (max-width: 1200px) {
		.info-container {
			padding-top: 0;
			h2 {
				font-size: 24px;
			}
		}
	}
	@media (max-width: 1200px) {
		padding-top: 30px;
		.img-container {
			height: auto;
			img {
				display: none;
			}
			.setup-btn {
				position: absolute;
				top: 450px;
				right: initial;
				left: 50%;
				transform: translateX(-50%);
			}
		}
		.activation-code {
			span {
				display: inline-block;
				white-space: nowrap;
				font-size: 12px;
			}
		}
		&.isNew {
			.info-container {
				width: 80%;
				padding-left: 0;
				.ant-btn {
					margin-top: 22px;
					font-size: 22px;
					height: auto;
				}
			}
		}
	}
`;

export default Wrapper;
